import { makeStyles } from '@material-ui/core'

export default makeStyles(() => ({
    bigContainer: {
        maxWidth: '100%',
        padding: '0px',
        marginTop: '67px',
    },
    container: {
        maxWidth: '100%',
        backgroundColor: '#e9e9e9',
        paddingBottom: '3vh',
        paddingTop: '3vh',
        paddingRight: '3vw',
        paddingLeft: '3vw',
    },
    title: {
        fontFamily: 'Helvetica, sans-serif',
        color: '#273746',
    },
    titleSgq: {
        fontFamily: 'Helvetica, sans-serif',
        color: '#273746',
        fontWeight: 'bold',
        '@media (min-width: 650px)': {
            fontSize: '33px',
        },
        '@media (max-width: 650px)': {
            fontSize: '22px',
        }
    },
    subtitleSgq: {
        fontFamily: 'Helvetica, sans-serif',
        color: '#273746',
        fontWeight: 'bold',
        '@media (min-width: 650px)': {
            fontSize: '25px',
        },
        '@media (max-width: 650px)': {
            fontSize: '15px',
        }
    },
    revisionSGQ: {
        fontSize: '10px',
    },
    description: {
        fontFamily: 'Helvetica, sans-serif',
        color: '#273746',
    },
    containerContato: {
        display: 'flex',
        '@media (min-width: 960px)': {
            flexDirection: 'row',
            marginBottom: '10vh',
            marginTop: '20vh',
        },
        '@media (max-width: 960px)': {
            flexDirection: 'column',
            alignItems: 'center',
            marginBottom: '5vh',
            marginTop: '15vh',
        },
    },
    addressContainer: {
        '@media (min-width: 960px)': {
            width: '35vw'
        },
        '@media (max-width: 960px)': {
            width: '90vw',
            paddingBottom: '5vh',
        }
    },
    isoImage: {
        '@media (min-width: 960px)': {
            height: '40vh',
        },
        '@media (max-width: 960px)': {
            width: '60vw',
        }
    },
    certificadoisoImg: {
        '@media (min-width: 960px)': {
            width: '20vw',
            height: 'auto',
        },
        '@media (max-width: 960px)': {
            width: '70vw',
        }
    },
    logoFatesImg: {
        '@media (min-width: 960px)': {
            width: '20vw',
            height: 'auto',
        },
        '@media (max-width: 960px)': {
            width: '30vw',
        }
    },
    isocontainer: {
        maxWidth: '100%',
        backgroundColor: '#e9e9e9',
        paddingBottom: '3vh',
        paddingTop: '3vh',
        paddingRight: '3vw',
        paddingLeft: '3vw',
        '@media (min-width: 960px)': {
            display: 'flex',
            flexDirection: 'row'
        }
    },
    rowColImg: {
        display: 'flex',
        '@media (min-width: 960px)': {
            flexDirection: 'row',
            justifyContent: 'space-between',
        },
        '@media (max-width: 960px)': {
            flexDirection: 'column',
        }
    },
    solImg: {
        '@media (min-width: 960px)': { 
            width: '50vw'
        }, 
        '@media (max-width: 960px)': { 
            width: '80vw'
        }
    },
    fbIcon: {
        width: '15px',
        height: '15px',
        marginRight: '7px',
    }
}))